import React from 'react';
import NavLinkComponent from './NavLinkComponent';
// наркоманія
const NavigationComponent = props => {
  const moreLink = (link, props, i) => {
    if (link.visibility && (link.headerLink || props.extended)) {
      return (
        <NavLinkComponent
          styles={props.styles}
          btn={link}
          title={link.title}
          key={i}
          menuHandler={props.menuHandler}
        />
      );
    }
    return false;
  };

  const subMenu = link => {
    if (props.extended) {
      return (
        props[link[0].openName] &&
        link.map((subLink, j) => (
          <NavLinkComponent
            styles={props.styles}
            title={subLink.title}
            btn={subLink}
            key={j}
            menuHandler={props.menuHandler}
          />
        ))
      );
    } else {
      return (
        <ul className={props.styles.subItem}>
          {link.map((subLink, j) => (
            <NavLinkComponent
              styles={props.styles}
              title={subLink.title}
              btn={subLink}
              key={j}
              menuHandler={props.menuHandler}
            />
          ))}
        </ul>
      );
    }
  };
  return (
    <ul className={props.styles.navigation}>
      {props.btn.map((link, i) => {
        if (Array.isArray(link)) {
          if (props.extended) {
            return link.map((subLink, j) => (
              <NavLinkComponent
                styles={props.styles}
                title={subLink.title}
                btn={subLink}
                key={j}
                menuHandler={props.menuHandler}
              />
            ));
          } else {
            return (
              <NavLinkComponent
                styles={props.styles}
                btn={link[0]}
                title={link[0].defaultTitle}
                key={i}
                nonEvent={link.length > 1}
                openSubMenu={props.openSubMenu}
                extended={props.extended}
                openName={link[0].openName}
                open={props[link[0].openName]}
                menuHandler={props.menuHandler}
              >
                {link.length > 1 && subMenu(link)}
              </NavLinkComponent>
            );
          }
        } else {
          return moreLink(link, props, i);
        }
      })}
    </ul>
  );
};

export default NavigationComponent;
